import React from "react";
import { CallbackComponent } from "redux-oidc";
import { useHistory } from "react-router-dom";
import userManager from "../../utils/userManager";

const CallbackPage = () => {
  const history = useHistory();

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={user => {
        const url = user.state.redirectUrl ? user.state.redirectUrl : "/";
        history.push(url);
      }}
      errorCallback={err => {
        console.log(err.message);
        //navigate("/")
      }}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
};

export default CallbackPage;
